import React from "react";
import { motion } from "framer-motion";
import { portfolioData } from "../data/portfolioData";

const Skills = () => {
  const { toolsAndTechnologies, sections } = portfolioData;

  return (
    <section id="skills" className="scroll-mt-24 py-14">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <h2 className="text-3xl font-bold text-slate-900">{sections.skillsTitle}</h2>
        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {toolsAndTechnologies.map((group, groupIndex) => (
            <motion.article
              key={group.category}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.3, delay: groupIndex * 0.05 }}
              className="rounded-xl border border-slate-200 bg-white/80 p-5 shadow-sm"
            >
              <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-indigo-700">
                {group.category}
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {group.items.map((tool) => (
                  <span
                    key={tool}
                    className="rounded-full border border-slate-300 bg-white px-3 py-1 text-sm font-medium text-slate-700"
                  >
                    {tool}
                  </span>
                ))}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
